<!--
 * @Author: mzw
 * @Date: 2021-09-24 09:12:16
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2022-01-12 15:17:06
 * @Description: 订单详情
-->
<template>
  <div class="home_page">
    <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item :to="{ name: 'basicInfo' }">{{$t('route.myAccount')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'orderList' }">{{$t('route.orderList')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="order_detail" style="margin-bottom: 20px">
      <div class="detail_body">
        <el-form :label-width="'112px'"
                 label-position="right"
                 v-if="orderDetail">
          <el-row class="basic-panel">
            <el-col :span="10">
              <h1 class="panel-title">{{$t('orderlist.orderDetail')}}（
                <span v-if="Number(orderDetail.orderStatus) != 90">{{$getDictLabel('ORDER_PAY_STATUS', orderDetail.payStatus)}}｜</span>
                <span>
                  <font v-if="Number(orderDetail.orderStatus)<=50">{{$t('orderlist.orderStatusOpt2')}}</font>
                  <font v-else>{{$getDictLabel('NEW_ORDER_STATUS' ,orderDetail.orderStatus)}}</font>
                </span>
                ）：</h1>
              <el-form-item :label="`${$t('orderdetail.orderNo')}：`">{{orderDetail.orderCode}}</el-form-item>
              <el-form-item :label="`${$t('orderdetail.principalPhone')}：`" label-width="140px" v-if="orderDetail.userSign && (orderDetail.contactName || orderDetail.contactPhone)">{{orderDetail.contactName}} {{orderDetail.contactPhone}}</el-form-item>
              <div class="detail-btn">
                <el-button type="done" @click="gotoPay" v-if="Number(orderDetail.payStatus)<'22' && orderDetail.orderStatus!='90'">立即支付</el-button>
                <!-- <el-button type="look" @click="downloadContract(orderDetail.payOrderContractRefactoryVo.contractUrl)" v-if="orderDetail.orderStatus!='90'">下载合同</el-button> -->
                <el-button type="cancle" @click="cancelOrderHandle" v-if="orderDetail.orderStatus=='10'">取消订单</el-button>
                <!-- <el-button type="done" @click="buyAgain" v-if="Number(orderDetail.orderStatus)>=80">再次购买</el-button> -->
              </div>
              <p class="handle-btn"><span class="icon-print" @click="toPrint">打印订单</span></p>
            </el-col>
            <el-col :span="14">
              <progressBar class="mb22" style="align-items: flex-end" :progressList="payList" :barTitle="$t('orderdetail.payment')" themeColor="blue"/>
              <progressBar class="mb22" style="align-items: flex-end" :progressList="deliverList" :barTitle="$t('orderdetail.shipment')" themeColor="orange"/>
              <progressBar style="align-items: flex-end" v-if="invoiceList.length" :progressList="invoiceList" :barTitle="'开票进度'" themeColor="blue"/>
            </el-col>
          </el-row>
        </el-form>

      </div>
    </div>
    <div class="order_detail">
      <div class="detail_body">
        <el-form ref="dataForm"
                 label-width="112px"
                 label-position="right"
                 v-if="orderDetail">
          <!-- 客户信息 -->
          <el-row class="basic-panel">
              <h1 class="panel-title">{{$t('order.customerInfo')}}：</h1>
              <el-col :span="12">
                <el-form-item v-if="$store.state.user.defaultCompanyId" :label="`${$t('order.customerCompany')}：`">{{orderDetail.companyName}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="`${$t('orderdetail.contact')}：`">{{orderDetail.payOrderAddressRefactoryVo.receiveGoodsPerson}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="`${$t('order.orderUser')}：`">{{orderDetail.userName}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="`${$t('orderdetail.phone')}：`">{{orderDetail.payOrderAddressRefactoryVo.receiveGoodsPhone}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="`${$t('orderlist.customerNo')}：`">{{orderDetail.custOrderNo || '-'}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="`${$t('order.address')}：`">{{orderDetail.payOrderAddressRefactoryVo.orderAddress || '-'}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="`要求到货日期：`" v-if="orderDetail.demandReceiveDate">{{orderDetail.demandReceiveDate}}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="`${$t('orderdetail.remark')}：`" style="color:#F81B1B" v-if="orderDetail.orderRemarks">{{orderDetail.orderRemarks}}</el-form-item>
              </el-col>
             
          </el-row>
          <!-- 发票信息 -->
          <el-row class="basic-panel" v-if="orderDetail.payOrderInvoiceRefactoryVo">
              <h1 class="panel-title">发票信息：<p class="handle-btn"><span class="icon-print" @click="billInfoVisible=true">发票详情</span></p></h1>
              <el-col :span="12">
                <el-form-item label="发票类型：">{{orderDetail.payOrderInvoiceRefactoryVo.invoiceType ===  '10' ? '普通发票' : '专用发票'}}</el-form-item>
              </el-col>
              <el-col :span="12" v-if="orderDetail.payOrderInvoiceRefactoryVo.payOrderInvoiceAddressRefactoryVo">
                <el-form-item label="收票联系人：">{{orderDetail.payOrderInvoiceRefactoryVo.payOrderInvoiceAddressRefactoryVo.receiveGoodsPerson}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发票抬头：">{{orderDetail.payOrderInvoiceRefactoryVo.companyName}}</el-form-item>
              </el-col>
              <el-col :span="12" v-if="orderDetail.payOrderInvoiceRefactoryVo.payOrderInvoiceAddressRefactoryVo">
                <el-form-item label="收票人电话：">{{orderDetail.payOrderInvoiceRefactoryVo.payOrderInvoiceAddressRefactoryVo.receiveGoodsPhone}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="税号：">{{orderDetail.payOrderInvoiceRefactoryVo.taxpayerIdentity}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收票地址：">{{orderDetail.payOrderInvoiceRefactoryVo.detailReceivingAddress}}</el-form-item>
              </el-col>
          </el-row>
          <el-row class="basic-panel" v-if="orderDetail.userSign">
            <!-- 合同信息 -->
            <el-col :span="12" v-if="orderDetail.payOrderContractRefactoryVo">
              <h1 class="panel-title">{{$t('orderdetail.contractInfo')}}：
                <p class="handle-btn">
                  <!-- <span class="icon-look">预览合同</span> -->
                  <span class="icon-load" @click="downloadContract(orderDetail.payOrderContractRefactoryVo.contractUrl)">{{$t('orderdetail.downloadContract')}}</span>
                </p>
              </h1>
              <el-form-item :label="`${$t('orderdetail.contractType')}：`">{{$t('order.contractType.' + orderDetail.payOrderContractRefactoryVo.contractType)}}</el-form-item>
              <el-form-item :label="`${$t('orderdetail.contractStatus')}：`">{{$getDictLabel("ORDER_CONTRACT_STATUS", orderDetail.payOrderContractRefactoryVo.contractStatus)}}</el-form-item>
            </el-col>
            <!-- 支付信息 -->
            <el-col :span="12">
              <h1 class="panel-title">{{$t('orderdetail.payInfo')}}：</h1>
              <el-form-item :label="`${$t('orderdetail.payType')}：`">{{$t('orderdetail.payHolder')}}</el-form-item>
              <el-form-item :label="`${$t('orderdetail.paymentType')}：`">{{orderDetail.payType=='10' ? $t('orderdetail.fullpayShip') : $t('orderdetail.otherShip')}}</el-form-item>
            </el-col>
          </el-row>
          <!-- 商品信息 -->
          <el-row class="basic-panel basic-panel-product" ref="productInfo" id="productInfo">
              <h1 class="panel-title">{{$t('order.productInfo')}}：</h1>
              <productBox :productList='orderDetail.payOrderItemRefactoryVos'
                          :isOperation='true'
                          :showOriginal='true'
                          :orderStatus="orderDetail.orderStatus"
                          @goodDetail='goodDetail'
                          @getLogisticsList='getLogisticsList' />
          </el-row>
          <!-- 订单价格 -->
          <el-row class="basic-panel">
              <el-col :span="24">
                  <orderPrice :priceData="priceData"
                      :hasRemark="false" />
              </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 物流弹窗 -->
      <logisticsBox :logisticsVisible="logisticsVisible" :logisticsList="logisticsList" :logisticsBasic="logisticsBasic" @handleLogClose='logisticsVisible=false'/>
      <!-- 发票弹窗 -->
      <billInfo :billInfoVisible="billInfoVisible" :billInfo="orderDetail.payOrderInvoiceRefactoryVo" @handleBillClose='billInfoVisible=false'
          v-if="orderDetail&&orderDetail.payOrderInvoiceRefactoryVo"></billInfo>

      <!-- -----分割线----- -->

      <!-- 上传合同 -->
      <!-- <el-dialog title="查看合同"
                 :visible.sync="contractVisible"
                 width="30%"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 :show-close="true"
                 class="order-detail-dialog">
        <el-upload ref="contractUpload"
                   :action="uploadURL"
                   accept=".jpg,.png,.docx,.doc,.pdf"
                   :file-list="contractList"
                   :on-preview="previewContractHandle"
                   :disabled="true">
          <el-button style="margin-left: 10px;"
                     size="small"
                     type="primary"
                     class="upload-button"
                     v-show="canUploadContrac">选择并上传</el-button>
        </el-upload>
      </el-dialog> -->
      <!-- 改价 -->
      <!-- <el-dialog
        title="再次改价"
        :visible.sync="priceChangeVisible"
        width="30%">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          placeholder="请输入内容"
          :maxlength="200"
          v-model="priceChangeDataForm.leaveMsg">
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button :loading="buttonLoading" @click="priceChangeVisible=false;priceChangeDataForm.leaveMsg='';">取 消</el-button>
          <el-button :loading="buttonLoading" type="primary" @click="confirmPriceChangeSubmitHandle">确 定</el-button>
        </span>
      </el-dialog> -->
    </div>
  </div>
</template>
<script>
import { openOther } from '@/utils'
import exportFun from '@/utils/export.js'
import orderPrice from './components/orderPrice'
import progressBar from './components/progressBar'
import productBox from './components/productBox'
import logisticsBox from './components/logisticsBox'
import billInfo from './components/billInfo'
export default {
  data () {
    return {
      orderDetail: null,
      goodsPage: 1, // 商品分页
      priceData: { // 价格相关数据
        payMoney: '',
        discountAmount: '',
        expressFee: '',
        totalPay: ''
      },
      payList: [], // 支付进度条
      deliverList: [], // 发货进度条
      invoiceList: [], // 开票进度进度条
      logisticsVisible: false, // 是否展示物流信息
      logisticsList: [], // 物流信息列表
      logisticsBasic: null, // 存放物流号+公司
      billInfoVisible: false // 是否展示发票信息
    }
  },
  components: { orderPrice, progressBar, productBox, logisticsBox, billInfo },
  computed: {
    orderId () {
      return this.$route.params.id
    }
  },
  watch: {
    orderId: {
      handler: 'getInfo',
      immediate: true
    }
  },
  methods: {
    // 查询订单详情
    getInfo () {
      if (!this.orderId) {
        return false
      }
      this.goodsPage = 1
      this.$request.get(`/front/consumer/shopping/order/orderInfo/${this.orderId}/false/1/10`)
        .then((res) => {
          this.orderDetail = res
          this.priceData = {
            payMoney: res.payMoney,
            discountAmount: res.discountAmount,
            expressFee: res.expressFee,
            totalPay: res.totalPay
          }
          // 支付进度
          let payList = []
          if (res.cancelTime || res.orderStatus === '90') { // 取消订单
            payList = [
              { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
              { title: this.$t('orderdetail.cancelled'), status: 'finished' }
            ]
          } else if (res.payStatus === '20') { // 待支付
            payList = [
              { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
              { title: this.$t('orderdetail.paid'), status: 'unfinished' }
            ]
          } else if (res.payStatus === '22') { // 部分支付
            payList = [
              { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
              { title: this.$t('orderdetail.partPaid'), status: 'finished' },
              { title: this.$t('orderdetail.paid'), status: 'unfinished' }
            ]
          } else if (res.payStatus === '24') { // 支付中
            payList = [
              { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
              { title: this.$t('orderdetail.paying'), status: 'unfinished' },
              { title: this.$t('orderdetail.paid'), status: 'unfinished' }
            ]
          } else if (res.payStatus === '29') { // 支付完成
            if (res.partPayTime) { // 含部分支付
              payList = [
                { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
                { title: this.$t('orderdetail.partPaid'), status: 'finished' },
                { title: this.$t('orderdetail.paid'), status: 'finished' }
              ]
            } else { // 无部分支付
              payList = [
                { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
                { title: this.$t('orderdetail.paid'), status: 'finished' }
              ]
            }
          }
          this.payList = payList
          // 发货进度
          let deliverList = []
          if (res.cancelTime || res.orderStatus === '90') { // 取消订单
            deliverList = [
              { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
              { title: this.$t('orderdetail.cancelled'), status: 'finished' }
            ]
          } else if (Number(res.orderStatus) <= 50 && res.createTime) { // 待发货
            deliverList = [
              { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
              { title: this.$t('orderdetail.shipped'), status: 'unfinished' },
              { title: this.$t('orderdetail.complete'), status: 'unfinished' }
            ]
          } else if (res.orderStatus === '60') { // 部分发货：部分发货√ 全部发货×
            deliverList = [
              { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
              { title: this.$t('orderdetail.partShip'), status: 'finished' },
              { title: this.$t('orderdetail.shipped'), status: 'unfinished' },
              { title: this.$t('orderdetail.complete'), status: 'unfinished' }
            ]
          } else if (res.orderStatus === '70' && !res.finishTime) { // 发货完成
            if (res.partDeliveryTime) { // 部分发货√ 全部发货√
              deliverList = [
                { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
                { title: this.$t('orderdetail.partShip'), status: 'finished' },
                { title: this.$t('orderdetail.shipped'), status: 'finished' },
                { title: this.$t('orderdetail.complete'), status: 'unfinished' }
              ]
            } else { // (无部分发货、即整单发货) 全部发货√
              deliverList = [
                { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
                { title: this.$t('orderdetail.shipped'), status: 'finished' },
                { title: this.$t('orderdetail.complete'), status: 'unfinished' }
              ]
            }
          } else if (res.finishTime) { // 已完成 即已签收
            if (res.partDeliveryTime) {
              deliverList = [
                { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
                { title: this.$t('orderdetail.partShip'), status: 'finished' },
                { title: this.$t('orderdetail.shipped'), status: 'finished' },
                { title: this.$t('orderdetail.complete'), status: 'finished' }
              ]
            } else {
              deliverList = [
                { title: this.$t('orderdetail.orderSubmit'), status: 'finished' },
                { title: this.$t('orderdetail.shipped'), status: 'finished' },
                { title: this.$t('orderdetail.complete'), status: 'finished' }
              ]
            }
          }
          this.deliverList = deliverList

          let invoiceList = []
          if (res.invoiceStatus) {
            invoiceList = [
              { title: this.$t('orderdetail.orderSubmit'), status: 'finished' }
            ]
            if (res.invoiceStatus === '10') {
              invoiceList.push(
                { title: '全部开票', status: 'unfinished' }
              )
            } else if (res.invoiceStatus === '20') {
              invoiceList.push(
                { title: '部分开票', status: 'finished' },
                { title: '全部开票', status: 'unfinished' }
              )
            } else if (res.invoiceStatus === '30') {
              invoiceList.push({ title: '全部开票', status: 'finished' })
            }
          }
          this.invoiceList = invoiceList

          // 如果有isToView，则跳转到指定位置
          if (this.$route.params.isToView) {
            this.$nextTick(() => {
              document.getElementById('productInfo').scrollIntoView()
            })
          }
        })
        .catch(() => {
          this.orderDetail = null
        })
    },
    // 去支付
    gotoPay () {
      if (this.orderDetail.customerPaymentMethod === '2') {
        this.$router.push({
          name: 'enterpriseTransferPayment',
          query: {
            id: this.orderId,
            money: this.orderDetail.totalPay || ''
          }
        })
        return
      }
      this.$router.push({
        name: 'orderPay',
        query: {
          id: this.orderId,
          money: this.orderDetail.totalPay || '',
          virtualAccount: this.orderDetail.virtualAccount || ''
        }
      })
    },
    // 跳转商品详情
    goodDetail (row) {
      openOther(`goodDetail?spuId=${row.goodsSpuId}&skuId=${row.goodsSkuId}`)
    },
    changeGoodsPage (page) {
      this.goodsPage = page
    },
    // 获取物流信息列表
    getLogisticsList (row) {
      this.logisticsVisible = true
      this.logisticsBasic = {
        ...row
      }

      let _this = this
      // this.$http.post(`/front/inter/bpmInterface/LogisticsInfo`,
      //   {
      //     'waybillnumber': row.logisticsNumber, // -- 单号
      //     'company': row.logisticsCompanyName // -- 公司名
      //     // 'tableno': bpmTableNo
      //   })
      //   .then((data) => {
      //     if (data.data.code === 0) {
      //       _this.logisticsList = data.data.data || []
      //     }
      //   })
      this.$http.get(`/help/consumer/logisticsCompany/getLogisticsInfo`, {
        params: {
          'logisticsNumber': row.logisticsNumber, // -- 单号
          'logisticsCompanyCode': row.logisticsCompanyCode, // -- code
          'phone': row.receiverPhone // -- 收件人
        }
      })
        .then((data) => {
          if (data.data.code === 0) {
            _this.logisticsList = data.data.data || []
          } else {
            _this.logisticsList = []
          }
        })
    },
    downloadContract (url) {
      if (url) {
        window.open(url)
      } else {
        this.$message.error(this.$t('orderlist.noContract'))
      }
    },
    // 取消订单
    cancelOrderHandle () {
      let _this = this
      this.$confirm(this.$t('message.isCancelOrder'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        _this.dataLoading = true
        _this.$http.post(`/front/consumer/shopping/order/cancelOrderById/${this.orderId}`)
          .then(({ data: res }) => {
            _this.dataLoading = false
            if (res.code === 0) {
              this.getInfo()
              _this.$message.success(this.$t('message.handleSuccess'))
              // _this.$router.go(-1)
            } else {
              return false
            }
          })
          .catch(() => {
            _this.dataLoading = false
          })
      })
    },
    // 再次购买
    buyAgain () {
      let shoppingCartFormList = JSON.stringify(this.orderDetail.payOrderItemRefactoryVos)
      this.$router.push({
        name: 'createOrder',
        query: {
          orderSource: '10',
          shoppingCartFormList
        }
      })
    },
    // 打印
    toPrint () {
      const fileName = `订单打印${this.orderDetail.orderCode}-${new Date().getTime()}.pdf` // 下载的文件名
      exportFun({
        url: `/front/consumer/shopping/order/downLoadPdf/${this.orderDetail.orderId}`,
        name: fileName,
        haveMsg: true
      }).then((t) => {
        // 操作成功
        if (t) {
          this.$message.success(this.$t('message.downloadSuccess'))
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
@import './common/buttonStyle.scss';
.mb22 {
  margin-bottom: 22px;
}
.order_detail{
  background: #fff;
  padding: 30px;
  .detail_body{
    width: 1136px;
    margin: 0 auto;
    .handle-btn{
      font-size: 12px;
      color: #3D88D4;
      font-weight: normal;
      display: inline-flex;
      margin: 0;
      &>span{
        display: flex;
        align-items: center;
        cursor: pointer;
        &::before{
          content: '';
          width: 16px;
          height: 16px;
          display: inline-block;
          background-size: 100%;
          margin-right: 6px;
        }
      }
      &>span.icon-print{
        &::before{
          background-image: url('./../../../assets/img/order/handlePrint.png');
        }
      }
      &>span.icon-bill{
        &::before{
          background-image: url('./../../../assets/img/order/handleBill.png');
        }
      }
      &>span.icon-look{
        &::before{
          background-image: url('./../../../assets/img/order/handleLook.png');
        }
      }
      &>span.icon-load{
        &::before{
          background-image: url('./../../../assets/img/order/handleLoad.png');
        }
      }
    }
    .basic-panel {
      margin-bottom: 20px;
      .panel-title {
          font-size: 20px;
          line-height: 28px;
          font-weight: 600;
          .handle-btn{
            &>span{
              margin-right: 15px;
            }
          }
      }
      /deep/ .el-form-item {
          margin-bottom: 0;
          .el-form-item__content{
            word-break: break-word;
            word-wrap: break-word;
          }
      }
    }
    // .discount{
    //   text-decoration: line-through;
    //   color: #aaaaaa;
    // }
    // .detail_row{
    //   display: flex;
    //   margin-top: 20px;
    //   color: #666666;
    //   align-items: center;
    //   .item_col{
    //     margin-right: 30px;
    //   }
    //   .top_title{
    //     font-size: 20px;
    //     // margin-top: 40px;
    //     font-weight: 600;
    //     color: #333333;
    //   }
    // }
    // .flex-between{
    //   justify-content: space-between;
    // }
    .detail-btn{
      margin: 12px 0;
      .el-button{
        min-width: 96px;
        height: 40px;
        border-radius: 4px;
        margin-right: 10px;
      }
    }
  }
}
</style>
